// Arabic (AR) translations for Find-2-Day
const ar = {
  translation: {
    "partnersStep3": "عندما يدفع نشاط تجاري قمت بإحضاره — اشتراكه الأول أو تجديدًا أو ترويجًا — تحصل على 50% من تلك الدفعة (باستثناء ضريبة القيمة المضافة). يظهر ذلك تلقائيًا في لوحة الشريك الخاصة بك، في كل مرة يدفعون فيها.",
    "partnersLede": "هل أنت سفير مدينة أو مجموعة مجتمعية أو قائد محلي؟ قدّم الأنشطة التجارية القريبة إلى Find-2-Day: تكسب 50% من كل دفعة يقومون بها (باستثناء ضريبة القيمة المضافة)، طالما بقوا معنا — اشتراكهم الأول، وكل تجديد، وكل ترويج أو منشور مموّل.",
    "partnersCommissionExplainer": "تكسب 50% من كل ما يدفعه نشاط تجاري قمت بإحضاره: اشتراكه الأول، وكل تجديد شهري أو سنوي، وكل ترويج أو منشور مموّل. الأسعار شاملة ضريبة القيمة المضافة 21%؛ وتُحتسب عمولتك على المبلغ بدون الضريبة.",
    "partnersRenewalHeading": "الاشتراكات والتجديدات",
    "partnersRenewalDesc": "50% من الدفعة الأولى ومن كل تجديد يقوم به نشاط تجاري محال، طالما ظل مشتركًا.",
    "partnersPoint2": "في اللحظة التي يدفعون فيها مقابل اشتراك أو تجديد أو ترويج أو منشور مموّل، تحصل على 50% مما دفعوه (باستثناء الضريبة).",
    "partnersPoint3": "كل نشاط تجاري تحضره يرتبط بك بشكل دائم. وطالما استمروا في الدفع، تستمر في كسب 50% — مدى الحياة.",
    "affEarnTitle": "ما الذي تكسبه لكل خطة",
    "affEarnIntro": "الأسعار شاملة ضريبة القيمة المضافة 21%. تُحتسب عمولتك البالغة 50% على المبلغ بدون الضريبة. الاشتراكات المؤهلة تدفع لك مدى الحياة — الدفعة الأولى وكل تجديد.",
    "affEarnColPlan": "الخطة",
    "affEarnColPrice": "السعر (شامل الضريبة)",
    "affEarnColCommission": "عمولتك (لكل دفعة)",
    "affEarnPerMonth": "/شهر",
    "affEarnPerYear": "/سنة",
    "affEarnPlanBasic": "Basic",
    "affEarnPlanPlus": "Business Plus",
    "affEarnLifetimeNote": "تكسب العمولة أعلاه عند دفعتهم الأولى وعند كل تجديد، طالما ظلوا مشتركين.",
    "affEarnBoostNote": "الترويجات والمنشورات المموّلة: تكسب أيضًا 50% من كل ترويج أو منشور مموّل مدفوع يشتريه نشاط تجاري محال.",
    "verifyEmailWarn": "يرجى تأكيد بريدك الإلكتروني لتفعيل دفعات العمولة.",
    "resendVerification": "إعادة إرسال البريد",
    "sending": "جارٍ الإرسال…",
    "verifyResent": "تم إرسال بريد التحقق — تحقق من صندوق الوارد.",
    "payoutHoldWarn": "تم تغيير بياناتك المصرفية مؤخرًا، لذا تم إيقاف الدفعات مؤقتًا للأمان.",
    "clawbackWarn": "سيُخصم رصيد مستحق قدره €{{amt}} ناتج عن استرداد/رد مبالغ من العمولات المستقبلية.",
    "downloadEarnings": "كشف الأرباح (CSV)",
    "downloadPayouts": "كشف الدفعات (CSV)",
    "partnersPoint1": "يمكن للأنشطة التجارية الانضمام إلى Find-2-Day بإدراج أساسي مجاني دائم في الدليل. تتوفر اشتراكات مدفوعة وخدمات ترويجية اختيارية. تحتفظ الأنشطة المؤسِّسة الحالية بمزايا الـ12 شهرًا المجانية الموعودة أصلاً.",
    "partnersPoint4": "تُحتجز العمولات لمدة 30 يومًا. إذا تم استرداد دفعة أو تمت تسوية نزاع ضدك، فقد تُعكس عمولتها. وقد تُخصم العمولات المدفوعة بالفعل من الأرباح المستقبلية.",
    "howPayoutsRule6": "إذا تم استرداد دفعة أو تمت تسوية نزاع ضدك، فقد تُعكس عمولتها — بما في ذلك العمولات المدفوعة بالفعل، التي قد تُخصم من الأرباح المستقبلية.",
    "lifetimeRenewalEarningsHint": "ستبدأ بكسب هذا عندما تجدّد الأنشطة التجارية التي أحلتها. لا شيء إضافي لتفعله — نحن نتتبعه نيابةً عنك.",
    "renewalCommissionTooltip": "عمولة مكتسبة لأن هذا النشاط التجاري جدّد اشتراكه",
    "communityPartner": {
      "title": "كن شريكًا مجتمعيًا",
      "label": "كن شريكًا مجتمعيًا",
      "tagline": "اكسب ",
      "taglineRest": " عمولة مدى الحياة على كل ما تدفعه الأنشطة التجارية التي تحيلها (باستثناء ضريبة القيمة المضافة).",
      "cta": "اعرف المزيد"
    },
    "membership": {
      "chooseTitle": "اختر عضويتك",
      "chooseSubtitle": "ابدأ مجانًا أو افتح ملفك الكامل. الأسعار شاملة ضريبة القيمة المضافة.",
      "freeForever": "مجاني للأبد · بدون بطاقة",
      "chooseFree": "اختر الدليل المجاني",
      "month": "شهر",
      "year": "سنة",
      "trial60": "أول 60 يومًا مجانًا",
      "ivaIncluded": "شامل الضريبة",
      "chooseBasic": "اختر الأساسي",
      "plusName": "Business Plus",
      "orAnnual": "أو",
      "choosePlusMonthly": "شهري",
      "choosePlusAnnual": "سنوي",
      "consentNote": "تبدأ الخطط المدفوعة بتجربة مجانية لمدة 60 يومًا. لن يتم خصم أي مبلغ حتى انتهاء التجربة، وفقط إذا وافقت. يمكنك الإلغاء في أي وقت.",
      "freeBadge": "الدليل المجاني",
      "freeTitle": "إدراج مجاني — €0 للأبد",
      "freeBody": "يتم نشر إدراجك الأساسي (اسم النشاط والفئة والبلدة) بعد الموافقة. بدون بطاقة. يمكنك الترقية إلى الأساسي أو Business Plus في أي وقت لعرض كل بياناتك.",
      "paidBody": "يتم نشر إدراجك بعد الموافقة. لن يتم خصم أي مبلغ خلال أول 60 يومًا. بعد انتهاء التجربة المجانية، يتم خصم المبلغ من بطاقتك تلقائيًا فقط إذا وافقت، ويمكنك الإلغاء في أي وقت قبل ذلك.",
      "firstChargeOn": "أول خصم (إذا تابعت):",
      "checkoutNotReady": "سيتم تفعيل الدفع الآمن بالبطاقة للخطط المدفوعة في الخطوة التالية (وضع اختبار Stripe). بيانات تسجيلك مكتملة وجاهزة — لم يتم خصم أي مبلغ.",
      "freeCta": "إنشاء إدراجي المجاني",
      "paidCta": "متابعة — بدء 60 يومًا مجانية",
      "freeName": "الدليل المجاني",
      "basicName": "الأساسي",
      "feat": {
        "free": ["اسم النشاط", "فئة النشاط", "البلدة", "ظهور أساسي في الدليل"],
        "basic": ["أول 60 يومًا مجانًا", "وصف كامل للنشاط", "الهاتف وبيانات الاتصال", "الموقع الإلكتروني ووسائل التواصل", "صور النشاط", "العنوان والخريطة والاتجاهات", "ظهور قياسي في البحث"],
        "plus": ["أول 60 يومًا مجانًا", "كل ما في الأساسي", "شارة Business Plus", "الترويج للفعاليات والعروض الخاصة"]
      }
    },
    "listShare": {
      "today": "تسوق اليوم",
      "todayHint": "قائمة تسوقك الحالية · قارن الأسعار",
      "myLists": "قوائمي",
      "noLists": "أنشئ قوائم لأي شيء — بقالة، أدوات، حطب، حيوانات أليفة، حديقة…",
      "newList": "قائمة جديدة",
      "namePh": "اسم القائمة (مثل تسوق أسبوعي، أدوات، حطب)",
      "nameRequired": "يرجى تسمية القائمة",
      "kind_personal": "خاصة",
      "kind_calendar": "المنزل",
      "kind_direct": "مشتركة",
      "hintPersonal": "خاصة بك وحدك.",
      "hintCalendar": "مشتركة مع جميع أعضاء ذلك التقويم.",
      "hintDirect": "شارك مع أشخاص محددين عبر البريد الإلكتروني.",
      "pickCalendar": "اختر تقويمًا…",
      "create": "إنشاء",
      "created": "تم إنشاء القائمة",
      "rename": "إعادة تسمية",
      "delListConfirm": "حذف هذه القائمة؟ ستتم إزالة عناصرها.",
      "share": "المشاركة مع شخص ما",
      "shared": "تمت مشاركة القائمة",
      "invite": "دعوة",
      "emailPh": "بريد مستخدم Find-2-Day الإلكتروني",
      "editingShared": "أنت تعمل على قائمة مشتركة",
      "shareHelp": "يمكن للأشخاص الذين تدعوهم عرض هذه القائمة وتعديلها، ويمكنهم رؤية أسماء وعناوين البريد الإلكتروني للآخرين الذين يشاركونها.",
      "remove": "إزالة",
      "addToWhich": "أضف إلى…",
      "addedToList": "تمت إضافة {{n}} إلى {{list}}",
      "addToListN": "أضف إلى القائمة ({{n}})",
      "copySelectedToList": "انسخ إلى القائمة ({{n}})",
      "listEmpty": "لا توجد منتجات بعد. أضف ما تشتريه.",
      "select": "تحديد",
      "compareThis": "قارن هذه القائمة",
      "addAll": "إضافة القائمة كاملة",
      "addSelected": "إضافة المحدد ({{n}})",
      "addSelectedShort": "إضافة المحدد",
      "addWholeShop": "إضافة كل المشتريات",
      "pickItems": "حدّد العناصر التي تحتاجها",
      "copiedToday": "تمت إضافة {{n}} إلى تسوق اليوم",
      "itemsN": "{{n}} عنصرًا",
      "repeatShop": "تكرار آخر تسوق",
      "repeatHint": "أضف عناصر من آخر إيصال لك",
      "repeatEmpty": "لم يتم العثور على تسوق سابق. امسح إيصالًا أولاً.",
      "favourite": "المفضلة",
      "favAdded": "أُضيف إلى المفضلة",
      "favRemoved": "أُزيل من المفضلة"
    },
    "priceEdit": {
      "title": "تفاصيل السعر", "edit": "تعديل السعر", "delete": "حذف", "save": "حفظ التغييرات", "cancel": "إلغاء",
      "confirmDelete": "حذف هذا السعر نهائيًا؟ لا يمكن التراجع عن ذلك.", "confirmYes": "نعم، احذف",
      "productName": "اسم المنتج", "price": "السعر", "brand": "العلامة التجارية", "packSize": "الحجم / العبوة", "quantity": "الكمية",
      "shop": "المورّد / المتجر", "town": "البلدة / الموقع", "date": "تاريخ التسجيل", "notes": "ملاحظات",
      "notesPh": "مثال: عرض خاص، سعر الولاء، عبوة كبيرة…", "optional": "اختياري",
      "saved": "تم تحديث السعر", "deleted": "تم حذف السعر",
      "errName": "يرجى إدخال اسم المنتج", "errPrice": "يرجى إدخال سعر صحيح",
      "errSave": "تعذّر تحديث السعر", "errDelete": "تعذّر حذف السعر"
    },
    "priceHistory": {
      "title": "سجل الأسعار", "none": "لا يوجد سجل أسعار بعد",
      "noneHint": "عند توفر المزيد من الأسعار المسجلة لهذا المنتج في هذا المتجر، سيظهر الاتجاه هنا.",
      "latest": "الأحدث", "rose": "ارتفع السعر", "fell": "انخفض السعر", "flat": "متقارب تقريبًا"
    },
    "pricePromo": {
      "title": "عروض Price-2-Day",
      "subtitle": "روّج لعرض منتج للمتسوقين القريبين",
      "slots": "الأماكن",
      "suspendedNote": "نشاطك التجاري موقوف حاليًا من العروض. يرجى التواصل مع الدعم.",
      "new": "عرض جديد",
      "embedTitle": "عروضي الترويجية",
      "promoteItem": "روّج منتجًا",
      "boostAgain": "روّج مجددًا",
      "noSlots": "لا توجد أماكن عروض متبقية. أرشِف عرضًا نشطًا لتحرير مكان.",
      "editTitle": "تعديل العرض",
      "createTitle": "إنشاء عرض",
      "product": "المنتج",
      "productPh": "مثال: زيت زيتون 2 لتر",
      "brand": "العلامة التجارية",
      "pack": "العبوة / الحجم",
      "normalPrice": "السعر العادي",
      "promoPrice": "سعر العرض",
      "description": "الوصف",
      "town": "البلدة / المنطقة",
      "branch": "المتجر / الفرع",
      "optional": "اختياري",
      "start": "تاريخ البدء",
      "end": "تاريخ الانتهاء",
      "availability": "نص التوفر",
      "availabilityPh": "مثال: حتى نفاد الكمية",
      "photo": "صورة",
      "photoError": "تعذّر رفع الصورة",
      "save": "حفظ",
      "publish": "نشر",
      "updated": "تم تحديث العرض",
      "published": "العرض الآن نشط",
      "submitted": "تم إرسال العرض للمراجعة",
      "archived": "تمت أرشفة العرض",
      "viewActive": "نشطة",
      "viewExpired": "منتهية",
      "empty": "لا توجد عروض هنا بعد.",
      "ends": "ينتهي",
      "sponsored": "مموّل",
      "sponsoredHint": "عرض مدفوع — ليس جزءًا من مقارنة الأسعار",
      "needProduct": "يرجى إدخال اسم المنتج",
      "needPromoPrice": "يرجى إدخال سعر العرض",
      "needEnd": "يرجى اختيار تاريخ الانتهاء",
      "saveError": "تعذّر حفظ العرض",
      "needDuration": "يرجى اختيار مدة العرض",
      "publishedFree": "عرضك المجاني الآن نشط",
      "ended": "تم إنهاء العرض",
      "startHint": "اتركه فارغًا لليوم",
      "duration": "مدة العرض",
      "days": "أيام",
      "free": "مجاني",
      "willEnd": "ينتهي",
      "testMode": "وضع المعاينة التجريبي — السعر معروض، بدون خصم فعلي",
      "introAvailable": "عرضك الأول لمدة 7 أيام مجاني (واحد لكل نشاط تجاري).",
      "introUsed": "تم استخدام العرض التعريفي المجاني.",
      "viewLive": "نشطة",
      "viewScheduled": "مجدولة",
      "edit": "تعديل",
      "endEarly": "إنهاء مبكر",
      "archive": "أرشفة",
      "status": { "live": "نشط", "scheduled": "مجدول", "pending": "قيد المراجعة", "suspended": "موقوف", "expired": "منتهٍ", "archived": "مؤرشف" }
    },
    "price": {
      "tagline": "امسح إيصالًا لقراءة أسعاره",
      "homeHeadline": "لنوفّر المال معًا",
      "homeTagline": "أسعار حقيقية. أشخاص حقيقيون. مجتمع أقوى.",
      "homeIntro": "امسح إيصالاتك، وشارك الأسعار، وقارن المتاجر وساعد الجميع في العثور على أفضل العروض.",
      "actListTitle": "قائمة تسوّقي",
      "actListSub": "ماذا أحتاج أن أشتري؟",
      "actSearchTitle": "ابحث عن أرخص سعر",
      "actSearchSub": "قارن الأسعار القريبة منك",
      "actScanTitle": "امسح وشارك الأسعار",
      "actScanSub": "أضف أسعار مشترياتي",
      "helpTitle": "إيصالاتك تساعد الجميع!",
      "helpBody": "عند مسح إيصال تسوّقك، نستخدم فقط معلومات المنتجات والأسعار لمساعدتك ومساعدة الآخرين في العثور على أفضل العروض.",
      "helpPrivacy": "نحن لا نجمع أو نحفظ بياناتك الشخصية أو معلومات الدفع/البطاقة أو صورة الإيصال.",
      "buyOftenTitle": "ما أشتريه كثيرًا",
      "buyOftenSub": "إضافة سريعة إلى قائمتي",
      "dealsBtnTitle": "عروض اليوم",
      "dealsBtnSub": "عروض خاصة قريبة منك",
      "backToMenu": "رجوع",
      "scanWhyTitle": "ساعد الجميع على التوفير",
      "scanWhyBody": "امسح إيصال تسوّقك وسنقرأ الأسعار. أسعارك تساعدك وتساعد الآخرين في المجتمع على معرفة أين تكون المنتجات أرخص.",
      "savedCommunityTitle": "شكرًا لك! \u2764\ufe0f",
      "savedCommunityBody": "تمت إضافة أسعارك. لقد ساعدت للتو متسوّقين آخرين في العثور على أسعار أفضل.",
      "slAddHeading": "ماذا تحتاج؟",
      "quickAddTitle": "إضافة سريعة",
      "regularTitle": "ما أشتريه بانتظام",
      "addToListBtn": "إضافة",
      "buyOftenEmpty": "ستظهر هنا المنتجات التي تشتريها كثيرًا، جاهزة للإضافة بنقرة واحدة.",
      "manageProductsLink": "إدارة منتجاتي المحفوظة",
      "addedToListToast": "تمت الإضافة إلى قائمة تسوّقك",
      "tabScan": "مسح",
      "tabSearch": "بحث",
      "tabFav": "المفضلة",
      "tabDeals": "عروض",
      "dist": { "pick": "اختر بلدتك لعرض المسافات", "list": "قائمة", "map": "خريطة", "soon": "قريبًا", "directions": "الاتجاهات", "unavailable": "الموقع غير متوفر بعد", "approxTravel": "المسافة تقريبًا", "extraTravel": "سفر إضافي تقريبًا", "productSaving": "توفير المنتجات", "vsOne": "مقابل متجر واحد", "partial": "بعض المواقع غير متوفرة بعد", "nearestNone": "لا يوجد متجر محدد الموقع بشكل موثوق لهذه العناصر بعد", "knownFor": "أسعار حديثة معروفة لـ {{covered}}/{{total}} عنصر" },
      "reviewNote": "راجع ما قرأه الذكاء الاصطناعي، وصحّح أي خطأ، ثم احفظ. لا يتم تخزين صورة الإيصال إطلاقًا — تُحفظ الأسعار فقط.",
      "scanTitle": "مسح الإيصال",
      "scanBlurb": "صوّر إيصالًا أو اختر واحدًا من هاتفك. يعمل مع أي متجر وأي لغة.",
      "receiptPrivacy": "خصوصية الإيصال: يُستخدم إيصالك فقط لقراءة معلومات المنتج والسعر. لا تُعرض صورة الإيصال علنًا ولا تُخزّن بشكل دائم في Price-2-Day. ولا تُضاف المعلومات الشخصية ومعلومات الدفع إلى قاعدة بيانات أسعار Price-2-Day.",
      "signInToScan": "يرجى تسجيل الدخول لمسح الإيصال وإرساله.",
      "signIn": "تسجيل الدخول",
      "takePhoto": "التقاط صورة",
      "choosePhoto": "اختيار صورة موجودة",
      "readingReceipt": "جارٍ قراءة الإيصال…",
      "receiptPreviewAlt": "معاينة الإيصال",
      "reviewTitle": "مراجعة وتصحيح",
      "reviewSubtitle": "عدّل أي حقل قرأه الذكاء الاصطناعي بشكل خاطئ.",
      "fShop": "المتجر",
      "fLocation": "الموقع / الفرع",
      "fDate": "التاريخ",
      "fCurrency": "العملة",
      "fTotal": "إجمالي الإيصال",
      "itemsLabel": "العناصر ({{count}})",
      "noItems": "لم يتم التعرف على أي عناصر.",
      "itemN": "العنصر {{n}}",
      "removeItem": "إزالة العنصر",
      "fDesc": "الوصف (كما هو مطبوع)",
      "fBrand": "العلامة التجارية",
      "fPackSize": "حجم العبوة",
      "fQty": "الكمية",
      "fUnitPrice": "سعر الوحدة",
      "fLineTotal": "إجمالي السطر",
      "fDiscount": "الخصم / العرض",
      "confirmSave": "تأكيد وحفظ الأسعار",
      "saving": "جارٍ الحفظ…",
      "cancel": "إلغاء",
      "signInHint": "يجب تسجيل الدخول للحفظ.",
      "savedTitle": "تمت إضافة الإيصال بنجاح",
      "savedBody": "شكرًا لمساهمتك. يمكنك إضافة أي عدد من الإيصالات.",
      "scanAnother": "مسح إيصال آخر",
      "searchPlaceholder": "ابحث عن منتج، مثل زيت الزيتون أو ACEITE",
      "searchBtn": "بحث",
      "sortLabel": "ترتيب:",
      "sortLowest": "الأقل سعرًا",
      "sortRecent": "الأحدث",
      "sortNearest": "الأقرب",
      "noResults": "لم يتم العثور على منتجات مطابقة. جرّب كلمات أخرى.",
      "asPrinted": "كما هو مطبوع",
      "lowestPrice": "أقل سعر",
      "lowestUnit": "أقل سعر للوحدة",
      "unknownShop": "متجر غير معروف",
      "shopsCount": "{{count}} متجر",
      "receiptDated": "إيصال بتاريخ",
      "offer": "عرض",
      "freshRecent": "حديث",
      "freshOlder": "أقدم",
      "freshHistorical": "قديم",
      "freshUnknown": "غير معروف",
      "disclaimer": "الأسعار المعروضة في Price-2-Day مبنية على معلومات مقدّمة من المجتمع. قد تكون قديمة أو تختلف حسب المتجر والوقت. تحقّق دائمًا في المتجر قبل الشراء.",
      "errMin2": "اكتب حرفين على الأقل للبحث.",
      "errHeic": "تعذّر قراءة صيغة الصورة. جرّب JPG أو PNG.",
      "errChooseImage": "من فضلك اختر صورة إيصال.",
      "errNoData": "تعذّر استخراج أي بيانات. جرّب صورة أوضح.",
      "errScan": "تعذّر قراءة الإيصال. حاول مرة أخرى.",
      "errNoItems": "أضف عنصرًا واحدًا على الأقل مع وصف قبل الحفظ.",
      "errSignIn": "سجّل الدخول لحفظ أسعار الإيصال.",
      "errDuplicate": "لقد أرسلت هذا الإيصال بالفعل.",
      "errSaveGeneric": "تعذّر الحفظ. حاول مرة أخرى.",
      "errSearch": "فشل البحث. حاول مرة أخرى.",
      "tabProducts": "منتجاتي",
      "tabList": "قائمة التسوق",
      "signInCta": "تسجيل الدخول",
      "errGeneric": "حدث خطأ ما. حاول مرة أخرى.",
      "edit": "تعديل",
      "delete": "حذف",
      "back": "رجوع",
      "mpSignIn": "سجّل الدخول للاحتفاظ بقائمتك الخاصة بالمنتجات التي تشتريها.",
      "mpAddTitle": "إضافة منتج",
      "mpNamePh": "اسم المنتج (مثل الحليب)",
      "mpBrandPh": "العلامة التجارية (اختياري)",
      "mpPackPh": "حجم العبوة (اختياري)",
      "mpAddBtn": "إضافة",
      "mpFromReceipt": "من الإيصال",
      "mpNameRequired": "الرجاء إدخال اسم المنتج.",
      "mpDuplicate": "هذا المنتج موجود بالفعل في منتجاتي.",
      "mpAdded": "تمت الإضافة إلى منتجاتي.",
      "mpEmpty": "لا توجد منتجات بعد. أضف الأشياء التي تشتريها بانتظام.",
      "mpToList": "بحاجة للشراء",
      "mpPickReceipt": "اختر أحد إيصالاتك المحفوظة",
      "mpNoReceipts": "ليس لديك إيصالات محفوظة بعد.",
      "mpTickItems": "حدّد العناصر لإضافتها إلى منتجاتي",
      "mpAddSelected": "إضافة المحدد",
      "mpPickOne": "اختر عنصرًا واحدًا على الأقل.",
      "mpFromReceiptDone": "تمت إضافة {{added}} · {{skipped}} موجودة مسبقًا",
      "itemsCount": "{{count}} عنصر",
      "status_have": "لدي ما يكفي",
      "status_low": "على وشك النفاد",
      "status_need": "بحاجة للشراء",
      "slSignIn": "سجّل الدخول للاحتفاظ بقائمة التسوق الخاصة بك.",
      "slAddTitle": "إضافة إلى قائمة التسوق",
      "slNamePh": "اكتب عنصرًا، مثل الخبز",
      "slNameRequired": "الرجاء إدخال عنصر.",
      "slIncreased": "تمت زيادة الكمية في قائمتك.",
      "slAdded": "تمت الإضافة إلى قائمة التسوق.",
      "slFromProductsHint": "نصيحة: اضغط \"بحاجة للشراء\" على منتج في منتجاتي لإضافته هنا.",
      "slEmpty": "قائمة التسوق فارغة.",
      "slTick": "وضع علامة كمُشترى",
      "slUntick": "إعادة إلى القائمة",
      "slBought": "تم شراؤها ({{n}})",
      "slClearCompleted": "مسح المكتملة",
      "slCleared": "تم مسح {{n}} عنصر.",
      "buyAgain": "شراء مجددًا",
      "buyAgainDone": "تمت الإضافة إلى قائمة التسوق.",
      "addToMyProductsTitle": "إضافة هذه إلى منتجاتي؟",
      "addToMyProductsBtn": "إضافة المحدد إلى منتجاتي",
      "addedToMyProducts": "تمت الإضافة إلى منتجاتي.",
      "cmpButton": "قارن تسوّقي",
      "cmpTitle": "قارن تسوّقي",
      "cmpOneShop": "متجر واحد",
      "cmpTwoShops": "متجران",
      "cmpCheapest": "الأرخص",
      "cmpNearest": "الأقرب",
      "cmpEstTotal": "الإجمالي التقديري",
      "cmpSaving": "التوفير التقديري",
      "cmpSubtotal": "المجموع الفرعي",
      "cmpCoverage": "تم العثور على أسعار لـ {{found}} من {{total}} عنصرًا.",
      "cmpNoRecent": "لا تتوفر مقارنة حديثة",
      "cmpNoData": "لا تتوفر أسعار لهذا الخيار بعد.",
      "cmpDisclaimer": "تقديري بناءً على أسعار إيصالات المجتمع. قد تكون الأسعار تغيّرت."
    },
    "notes": {
      "back": "الملاحظات", "overviewHint": "ملاحظات خاصة ومشتركة لهذا التقويم.",
      "createNote": "إنشاء ملاحظة", "editNote": "تعديل الملاحظة", "title": "العنوان", "text": "النص",
      "textPlaceholder": "اكتب ملاحظتك هنا …", "colour": "اللون", "privacy": "الخصوصية",
      "private": "خاصة", "shared": "مشتركة", "privateHint": "أنت وحدك من يمكنه رؤية هذه الملاحظة.",
      "sharedHint": "بعد الحفظ، اختر أعضاء التقويم لمشاركتها معهم.",
      "formHint": "امنح ملاحظتك عنوانًا ونصًا. الملاحظات خاصة ما لم تشاركها.",
      "save": "حفظ", "cancel": "إلغاء", "open": "فتح", "edit": "تعديل", "delete": "حذف",
      "copy": "نسخ النص", "share": "مشاركة", "manageSharing": "إدارة المشاركة",
      "memberEmail": "بريد العضو الإلكتروني",
      "shareDialogHint": "أدخل البريد الإلكتروني الدقيق لعضو في التقويم. يجب أن يكون عضوًا في هذا التقويم بالفعل.",
      "noneShared": "لم تتم المشاركة مع أحد بعد.", "sharedWith": "مشتركة مع", "sharedTag": "مشتركة معك",
      "readOnly": "لديك صلاحية القراءة فقط لهذه الملاحظة.", "empty": "لا تحتوي هذه الملاحظة على نص بعد.",
      "emptyTitle": "لا توجد ملاحظات بعد", "emptyHint": "أنشئ أول ملاحظة خاصة أو مشتركة.",
      "deleteNote": "حذف الملاحظة",
      "deleteConfirm": "سيؤدي هذا إلى حذف الملاحظة نهائيًا. لا يمكن التراجع عن ذلك.",
      "created": "تم إنشاء الملاحظة", "updated": "تم تحديث الملاحظة", "deleted": "تم حذف الملاحظة",
      "copied": "تم نسخ الملاحظة إلى الحافظة",
      "shareCopied": "المشاركة غير مدعومة هنا – تم نسخ الملاحظة بدلاً من ذلك", "shareSaved": "تم تحديث المشاركة",
      "loadError": "تعذّر تحميل الملاحظات", "openError": "هذه الملاحظة غير متاحة",
      "saveError": "تعذّر حفظ الملاحظة", "deleteError": "تعذّر حذف الملاحظة",
      "copyError": "تعذّر نسخ الملاحظة", "shareError": "تعذّر مشاركة الملاحظة",
      "shareUpdateError": "تعذّر تحديث المشاركة",
      "dragHandle": "اسحب لإعادة الترتيب", "reorderHint": "اسحب ملاحظة من مقبضها لإعادة الترتيب، أو استخدم السهمين ▲ ▼",
      "moveUp": "تحريك لأعلى", "moveDown": "تحريك لأسفل", "reorderError": "تعذّرت إعادة الترتيب"
    },
    "lists": {
      "back": "القوائم", "overviewHint": "قوائم خاصة ومشتركة لهذا التقويم.",
      "createList": "إنشاء قائمة", "editList": "تعديل القائمة", "name": "الاسم", "colour": "اللون",
      "privacy": "الخصوصية", "private": "خاصة", "shared": "مشتركة",
      "privateHint": "أنت وحدك من يمكنه رؤية هذه القائمة وإدارتها.",
      "sharedHint": "أنت تحدد بالضبط أي أعضاء التقويم يمكنهم الوصول إليها.",
      "formHint": "سمِّ قائمتك واختر لونًا وحدّد من يمكنه رؤيتها.",
      "save": "حفظ", "cancel": "إلغاء", "delete": "حذف", "duplicate": "تكرار",
      "editItem": "تعديل العنصر", "deleteList": "حذف القائمة",
      "deleteConfirm": "سيؤدي هذا إلى حذف القائمة وجميع عناصرها نهائيًا. لا يمكن التراجع عن ذلك.",
      "manageSharing": "إدارة المشاركة", "memberEmail": "بريد العضو الإلكتروني",
      "shareHint": "أدخل البريد الإلكتروني الدقيق لعضو في التقويم. يجب أن يكون عضوًا في هذا التقويم بالفعل.",
      "noneShared": "لم تتم المشاركة مع أحد بعد.", "sharedWith": "مشتركة مع", "sharedTag": "مشتركة معك",
      "readOnly": "لديك صلاحية القراءة فقط لهذه القائمة.", "noItems": "لا توجد عناصر بعد.",
      "newItem": "عنصر جديد", "itemText": "العنصر", "itemPlaceholder": "مثال: حليب",
      "quantity": "الكمية", "qty": "الكمية", "done": "تم", "emptyTitle": "لا توجد قوائم بعد",
      "emptyHint": "أنشئ أول قائمة خاصة أو مشتركة.", "dragHandle": "اسحب لإعادة الترتيب",
      "reorderHint": "اسحب المقبض لإعادة الترتيب، أو استخدم السهمين ▲ ▼", "reorderListsHint": "اسحب قائمة من مقبضها لإعادة الترتيب",
      "itemTextRequired": "نص العنصر مطلوب", "created": "تم إنشاء القائمة", "updated": "تم تحديث القائمة",
      "deleted": "تم حذف القائمة", "duplicated": "تم إنشاء نسخة خاصة", "itemUpdated": "تم تحديث العنصر",
      "loadError": "تعذّر تحميل القوائم", "openError": "هذه القائمة غير متاحة",
      "saveError": "تعذّر حفظ القائمة", "deleteError": "تعذّر حذف القائمة",
      "dupError": "تعذّر تكرار القائمة", "itemError": "تعذّر إضافة العنصر",
      "itemError2": "تعذّر تحديث العنصر", "itemDelError": "تعذّر حذف العنصر",
      "reorderError": "تعذّرت إعادة الترتيب", "shareSaved": "تم تحديث المشاركة",
      "shareError": "تعذّر تحديث المشاركة"
    },
    "bookingCal": {
      "pickDate": "اختر تاريخًا",
      "repeat": "تكرار", "repeatEditHint": "غيّر طريقة تكرار هذا الحجز",
      "repeatNone": "بدون تكرار", "repeatDaily": "كل يوم", "repeatWeekly": "كل أسبوع",
      "repeatBiweekly": "كل أسبوعين", "repeatMonthly": "كل شهر", "repeatCustom": "مخصص",
      "endDateRequired": "يرجى اختيار تاريخ انتهاء للتكرار",
      "repeatUpdated": "تم تحديث التكرار – {n} حجوزات", "repeatRemoved": "لم يعد هذا الحجز يتكرر",
      "savedEdit": "تم تحديث الحجز", "savedDupGroup": "تم تحديث جميع الحجوزات المكررة",
      "deleted": "تم نقل الحجز إلى سلة المحذوفات", "skipDate": "تخطي هذا التاريخ",
      "skipDateQ": "تخطي هذا التاريخ؟",
      "skipDateDesc": "سيُزال {date} فقط. تبقى بقية السلسلة المتكررة دون تغيير. يمكنك استعادته لاحقًا من سلة المحذوفات.",
      "dateSkipped": "تم تخطي هذا التاريخ – تبقى بقية التكرار دون تغيير",
      "repeatsPrefix": "يتكرر", "recEveryDay": "كل يوم", "recEveryNDays": "كل {n} أيام",
      "recEveryWeek": "كل أسبوع", "recEvery2Weeks": "كل أسبوعين", "recEveryNWeeks": "كل {n} أسابيع",
      "recOn": "في", "recMonthly": "شهريًا", "recEveryNMonths": "كل {n} أشهر", "recUntil": "حتى {d}",
      "recForN": "لـ {n} مرات", "repeats": "حجز متكرر", "repeatsShort": "يتكرر",
      "dupDelTitle": "حذف الحجز المكرر",
      "dupDelIntro": "هذا الحجز واحد من {n} تم إنشاؤها معًا عبر التكرار.",
      "dupDelThis": "حذف هذا الحجز فقط", "dupDelAll": "حذف جميع الحجوزات المكررة",
      "dupDelAllGo": "حذف الكل", "dupDelSelect": "اختر الحجوزات المراد حذفها",
      "dupDelSelectedGo": "حذف المحدد",
      "dupDelAllConfirm": "حذف كل الـ {n} حجوزات المكررة؟ ستُنقل إلى سلة المحذوفات.",
      "dupDelPickOne": "يرجى اختيار حجز واحد على الأقل.", "dupDelDone": "تم حذف {n} حجز/حجوزات",
      "dupDelPartial": "تم حذف {ok}؛ فشل {fail}",
      "dupDelFailed": "تعذّر حذف الحجوزات المكررة",
      "listsNav": "القوائم", "notesNav": "الملاحظات"
    },
    "eventCreateFailed": "تعذّر إنشاء الفعالية. حاول مرة أخرى.",
    "eventUpdateFailed": "تعذّر تحديث الفعالية. حاول مرة أخرى.",
    "eventsBlockedTrialEnded": "انتهت فترتك التجريبية. أضِف طريقة دفع لنشر الفعاليات مجدداً.",
    "eventsBlockedPlan": "خطتك الحالية لا تتضمّن الفعاليات. قم بالترقية لنشر الفعاليات.",
    "eventsBlockedMax": "لقد وصلت إلى الحد الأقصى وهو {{max}} فعاليات نشطة. أرشِف فعالية بالأسفل أو اشترك في Featured للمزيد.",
    "eventsActiveHint": "النشطة = الفعاليات الجارية والقادمة فقط. الفعاليات الماضية/المنتهية لا تُحتسب ضمن حدّك.",
    "home": {
      "heroTagline": "كل ما يحدث في مدينتك.",
      "startCardTitle": "ابدأ",
      "startCardDesc": "اكتشف كل ما يحدث في مدينتك.",
      "businessCardTitle": "الأعمال",
      "businessCardDesc": "روّج لنشاطك التجاري أو مؤسستك أو مجموعتك المجتمعية.",
      "discoverTitle": "اكتشف الأنشطة التجارية والفعاليات",
      "localAlertsTitle": "مركز سلامة المجتمع",
      "classifiedsTitle": "بيع · مفقود · موجود",
      "bankHolidaysTitle": "العطلات الرسمية",
      "emergencyTitle": "أرقام الطوارئ",
      "businessSignInTitle": "لديك حساب تجاري بالفعل؟ سجّل الدخول",
      "businessCalendarTitle": "تقويم الأعمال"
    },
    "frontpage": {
      "claimExistingBusinessTitle": "طالب بنشاط تجاري أو أضفه",
      "charityApplyTitle": "إعلان مجتمعي / خيري"
    },
    "frontpageEarnCommission": "كن شريكاً مجتمعياً",
    "dismiss": "إغلاق",
    "safetyOptInTitle": "لا تفوّت أي تنبيه سلامة",
    "safetyOptInBody": "احصل على تنبيهات السلامة الرسمية مباشرةً على هاتفك حتى لا تفوّت أي معلومات مهمة من مجتمعك.",
    "safetyOptInCta": "تفعيل تنبيهات الهاتف",
    "safetyOptInEnabling": "جارٍ التفعيل…",
    "safetyOptInError": "تعذّر تفعيل التنبيهات. يرجى المحاولة مرة أخرى.",
    "appTitle": "Find-2-day",
    "appBadgeTitle": "تنبيهات على هاتفك",
    "appBadgeDesc": "إظهار شارة على أيقونة التطبيق وإشعار عند وصول تنبيه سلامة جديد — حتى عندما يكون التطبيق مغلقاً.",
    "appBadgeUnsupported": "غير مدعوم على هذا الجهاز",
    "appBadgeEnabled": "تنبيهات الهاتف مفعّلة. ثبّت Find-2-Day على شاشتك الرئيسية لإظهار الشارة على الأيقونة.",
    "appBadgeFallback": "جهازك يعرض الإشعارات لكن دون شارة على الأيقونة — ستظل تتلقى مؤشر الجرس داخل التطبيق.",
    "appTagline": "اكتشف المحلات والتجارب والفعاليات والأنشطة القريبة منك",
    "getStarted": "ابدأ الآن",
    "listYourBusiness": "سجّل نشاطك التجاري",
    "signIn": "تسجيل الدخول",
    "joinBusiness": "انضم كنشاط تجاري",
    "categories": {
      "food": "مطاعم وطعام",
      "music": "موسيقى وحياة ليلية",
      "family": "أنشطة عائلية",
      "offers": "عروض خاصة",
      "wellbeing": "صحة ورفاهية"
    },
    "nav": {
      "discover": "اكتشف",
      "favorites": "المفضلة",
      "events": "الفعاليات",
      "offers": "العروض",
      "profile": "الملف الشخصي",
      "forSale": "بيع / مفقود / موجود",
      "communityHub": "المجتمع"
    },
    "welcomeBack": "مرحباً بعودتك!",
    "signInSubtitle": "سجّل دخولك للمتابعة",
    "emailOrUsername": "البريد الإلكتروني",
    "password": "كلمة المرور",
    "rememberMe": "تذكرني",
    "forgotPassword": "نسيت كلمة المرور؟",
    "forgotPasswordTitle": "نسيت كلمة المرور؟",
    "forgotPasswordDesc": "أدخل بريدك الإلكتروني وسنرسل لك رابط إعادة التعيين.",
    "forgotPasswordError": "حدث خطأ. يرجى المحاولة مرة أخرى.",
    "sendResetLink": "إرسال الرابط",
    "sending": "جارٍ الإرسال...",
    "checkYourEmail": "تحقق من بريدك الإلكتروني",
    "resetEmailSent": "إذا كان الحساب موجوداً، فقد أرسلنا رابط إعادة التعيين. تحقق من صندوق الوارد.",
    "backToSignIn": "العودة لتسجيل الدخول",
    "setNewPassword": "تعيين كلمة مرور جديدة",
    "setNewPasswordDesc": "اختر كلمة مرور قوية من 6 أحرف على الأقل.",
    "newPassword": "كلمة المرور الجديدة",
    "confirmPassword": "تأكيد كلمة المرور",
    "resetPassword": "إعادة تعيين",
    "resetting": "جارٍ إعادة التعيين...",
    "passwordReset": "تم إعادة تعيين كلمة المرور",
    "passwordResetSuccess": "تم إعادة تعيين كلمة المرور بنجاح.",
    "invalidResetLink": "رابط غير صالح",
    "invalidResetLinkDesc": "هذا الرابط غير صالح أو منتهي الصلاحية.",
    "requestNewLink": "طلب رابط جديد",
    "passwordMinLength": "كلمة المرور يجب أن تكون 6 أحرف على الأقل",
    "passwordsMustMatch": "كلمات المرور غير متطابقة",
    "emailAddress": "عنوان البريد الإلكتروني",
    "dontHaveAccount": "ليس لديك حساب؟",
    "signUp": "إنشاء حساب",
    "businessSignUp": "تسجيل نشاط تجاري",
    "joinAsBusinessTitle": "انضم كنشاط تجاري",
    "freeTrialOffer": "ابدأ بإدراج نشاطك فوراً",
    "accountInformation": "معلومات الحساب",
    "fullName": "الاسم الكامل",
    "email": "البريد الإلكتروني",
    "businessInformation": "معلومات النشاط التجاري",
    "businessName": "اسم النشاط التجاري",
    "description": "الوصف",
    "tellUsAbout": "أخبرنا عن نشاطك التجاري...",
    "continue": "متابعة",
    "fullNamePlaceholder": "أحمد محمد",
    "passwordPlaceholder": "أنشئ كلمة مرور قوية",
    "businessNamePlaceholder": "اسم نشاطك التجاري",
    "stepOf": "الخطوة {{step}} من {{total}}",
    "allFieldsRequired": "جميع الحقول مطلوبة",
    "businessNameDescRequired": "اسم النشاط والوصف مطلوبان",
    "fillAllRequired": "يرجى ملء جميع الحقول المطلوبة",
    "registrationFailed": "فشل التسجيل. يرجى المحاولة مرة أخرى.",
    "emailAlreadyRegistered": "هذا البريد الإلكتروني مسجل بالفعل.",
    "contactLocation": "الاتصال والموقع",
    "categoryLabel": "الفئة",
    "selectCategory": "اختر فئة",
    "cityLabel": "المدينة",
    "businessAddress": "عنوان النشاط التجاري",
    "phoneNumber": "رقم الهاتف",
    "businessEmailLabel": "البريد الإلكتروني للنشاط",
    "websiteLabel": "الموقع الإلكتروني",
    "openingHoursLabel": "ساعات العمل",
    "chooseYourPlan": "اختر خطتك",
    "perMonth": "شهر",
    "plusIVA": "شامل الضريبة",
    "bestValue": "أفضل قيمة",
    "selected": "محدد",
    "freeTrialTitle": "ابدأ فوراً",
    "proceedToPayment": "المتابعة للدفع",
    "alreadyHaveAccount": "لديك حساب بالفعل؟",
    "timeTo": "إلى",
    "closed": "مغلق",
    "dayMonday": "الاثنين",
    "dayTuesday": "الثلاثاء",
    "dayWednesday": "الأربعاء",
    "dayThursday": "الخميس",
    "dayFriday": "الجمعة",
    "daySaturday": "السبت",
    "daySunday": "الأحد",
    "plan6months": "6 أشهر",
    "plan12months": "أفضل إعداد / وصول كامل",
    "featured": "مميز",
    "searchPlaceholder": "البحث عن أنشطة تجارية...",
    "logout": "تسجيل الخروج",
    "all": "الكل",
    "callNow": "اتصل الآن",
    "emailButton": "بريد إلكتروني",
    "openingHours": "ساعات العمل",
    "pendingApprovalTitle": "في انتظار الموافقة",
    "pendingApprovalDesc": "نشاطك التجاري قيد المراجعة",
    "trialDaysRemaining": "{{days}} يوم متبقي",
    "businessVisible": "نشاطك التجاري مرئي للمستخدمين",
    "subscriptionActive": "الاشتراك نشط",
    "subscriptionExpired": "الاشتراك منتهي",
    "activeFilters": "الفلاتر النشطة",
    "noBusinessesFound": "لم يتم العثور على أنشطة تجارية.",
    "tryDifferentFilters": "جرّب فلاتر أو كلمات بحث مختلفة.",
    "clearFilters": "مسح الفلاتر",
    "businessFound": "نشاط تجاري",
    "businessesFound": "أنشطة تجارية",
    "filters": "فلاتر",
    "resetAll": "إعادة تعيين الكل",
    "applyFilters": "تطبيق الفلاتر",
    "settings": "الإعدادات",
    "language": "اللغة",
    "notifications": "الإشعارات",
    "noEventsYet": "لا توجد فعاليات بعد",
    "browseBusinesses": "تصفح الأنشطة التجارية",
    "noOffersYet": "لا توجد عروض بعد",
    "noFavoritesYet": "لا توجد مفضلات بعد",
    "discoverBusinesses": "اكتشف الأنشطة التجارية",
    "save": "حفظ",
    "saved": "محفوظ",
    "cancel": "إلغاء",
    "consentText": "أوافق على",
    "consentAnd": "و",
    "termsAndConditions": "الشروط والأحكام",
    "privacyPolicyTitle": "سياسة الخصوصية",
    "back": "رجوع",
    "submit": "إرسال",
    "or": "أو",
    "loading": "جارٍ التحميل...",
    "error": "خطأ",
    "success": "نجاح",
    "goBack": "رجوع",
    "goHome": "الصفحة الرئيسية",
    "about": "حول",
    "share": "مشاركة",
    "copyLink": "نسخ الرابط",
    "linkCopied": "تم النسخ!",
    "shareMore": "المزيد",
    "shareDefaultText": "اطلع على هذا الإعلان على Find-2-Day!",
    "reviews": "التقييمات",
    "writeReview": "كتابة تقييم",
    "noReviewsYet": "لا توجد تقييمات بعد. كن الأول!",
    "loginToReview": "سجّل دخولك لكتابة تقييم",
    "favourite": "حفظ",
    "favourited": "محفوظ",
    "resetFilters": "إعادة تعيين الفلاتر",
    "offers": "العروض",
    "activeOffers": "عروض نشطة",
    "upcomingEvents": "فعاليات قادمة",
    "daysLeft": "أيام متبقية",
    "manageSubscription": "إدارة الاشتراك",
    "onboardingTitle": "مرحباً بك في Find-2-Day!",
    "onboardingStep1Title": "اكتشف الإعلانات المحلية",
    "onboardingStep1Desc": "تصفح الأنشطة التجارية والجمعيات والفعاليات والعروض القريبة منك.",
    "onboardingStep2Title": "احفظ مفضلاتك",
    "onboardingStep2Desc": "انقر على القلب لحفظ الإعلانات.",
    "onboardingStep3Title": "احصل على إشعارات",
    "onboardingStep3Desc": "انقر على 'إشعارات' للحصول على تحديثات فورية.",
    "onboardingGotIt": "فهمت!",
    "onboardingNext": "التالي",
    "onboardingSkip": "تخطي",
    "locationPicker": {
      "title": "احصل على تنبيهات منطقتك",
      "intro": "اختر بلدتك في ألميريا لنرسل لك الأحداث والعروض وتنبيهات السلامة القريبة.",
      "homeTownLabel": "بلدتك أو قريتك",
      "searchPlaceholder": "ابحث عن بلدات ألميريا…",
      "noTowns": "لا توجد بلدات مطابقة.",
      "nearbyLabel": "نبّهني عن البلدات القريبة أيضاً",
      "nearbyHint": "ضمن {{km}} كم من بلدتك. يمكن تعديله.",
      "radiusAria": "نطاق القرب بالكيلومترات",
      "regionLabel": "تنبيهات لكل ألميريا",
      "regionHint": "الأحداث في عموم المقاطعة والعروض الكبرى وتنبيهات السلامة.",
      "followedTownsLabel": "تابع هذه البلدات أيضاً (اختياري)",
      "followedTownsHint": "اختر بلدات إضافية بجانب بلدتك الأصلية.",
      "followedTownsAddPlaceholder": "أضف بلدة…",
      "removeTown": "إزالة",
      "skip": "ليس الآن",
      "save": "احفظ منطقتي",
      "saving": "جارٍ الحفظ…"
    },
    "categoryFood": "مطاعم وطعام",
    "categoryMusic": "موسيقى وحياة ليلية",
    "categoryShopping": "تسوق",
    "categoryHealthWellness": "صحة ورفاهية",
    "categoryEvents": "فعاليات وترفيه",
    "categoryEducation": "تعليم",
    "categoryHomeServices": "خدمات منزلية",
    "categoryTravel": "سفر وسياحة",
    "categoryBeautySpa": "جمال وسبا",
    "categorySports": "رياضة ولياقة",
    "categoryArts": "فنون وثقافة",
    "categoryProfessional": "خدمات مهنية",
    "categoryAutomotive": "سيارات",
    "categoryTechnology": "تكنولوجيا",
    "categoryVets": "أطباء بيطريون",
    "categoryVolunteerWork": "تطوع",
    "categoryJobs": "وظائف",
    "categoryCommunityHelp": "مساعدة مجتمعية",
    "categoryCommunity": "مجتمع",
    "categoryOther": "أخرى",
    "pwaInstallTitle": "تثبيت Find-2-Day",
    "pwaInstallBtn": "تثبيت",
    "whatsNew_title": "ما الجديد",
    "whatsNew_item1": "تنبيهات فورية من أعمالك المفضلة — فعاليات وعروض وأكثر",
    "whatsNew_item2": "يعمل على جميع الأجهزة — إشعارات Push مع بديل عبر البريد الإلكتروني",
    "whatsNew_cta": "إشعارات للفعاليات والعروض",

    "marketplace": {
      "tabSell": "بيع", "tabWanted": "مطلوب", "tabSwap": "مقايضة", "tabFree": "مجاني",
      "hintMarketTitle": "الشراء أو البيع أو المقايضة أو التبرع",
      "swapTitle": "SWAP-2-DAY", "swapSubtitle": "ماذا لديك؟ وبماذا تريد مقايضته؟",
      "swapLabel": "مقايضة", "orSwap": "أو مقايضة"
    },
    "swap": {
      "moneyNone": "لا شيء", "moneyBtoA": "يدفع مقدّم العرض للمالك €{n}", "moneyAtoB": "يدفع المالك لمقدّم العرض €{n}",
      "ownerProvides": "يقدّم المالك", "offererProvides": "يقدّم مقدّم العرض", "money": "مبلغ إضافي",
      "negotiation": "مفاوضة المقايضة", "youAre": "أنت", "owner": "صاحب الإعلان", "offerer": "الشخص الذي يقدّم العرض",
      "agreed": "تمت الموافقة على المقايضة", "agreedAt": "تم الاتفاق في", "finalTerms": "الشروط النهائية المتفق عليها", "currentTerms": "الشروط الحالية",
      "confirmed": "تم التأكيد ✓", "notConfirmed": "ليس بعد", "ownerLabel": "المالك", "offererLabel": "مقدّم العرض",
      "iAgree": "أوافق على هذه المقايضة", "youConfirmed": "لقد أكّدت – في انتظار الشخص الآخر",
      "counter": "عرض مضاد", "decline": "رفض", "withdraw": "سحب عرضي", "cancel": "إلغاء هذه المفاوضة",
      "history": "سجل العروض", "makeCounter": "تقديم عرض مضاد", "commaSep": "مفصولة بفواصل",
      "moneyAmount": "المبلغ (€)", "moneyDir": "اتجاه الدفع", "dirNone": "بدون مال", "dirBtoA": "يدفع مقدّم العرض للمالك", "dirAtoB": "يدفع المالك لمقدّم العرض",
      "notePlaceholder": "ملاحظة اختيارية…", "sendCounter": "إرسال العرض المضاد", "backToMarket": "العودة إلى السوق",
      "loadFail": "تعذّر تحميل هذه المقايضة.", "actionFail": "فشل الإجراء.",
      "ownerGives": "يقدّم المالك", "describeYours": "صِف ما ستقدّمه في المقابل (يمكنك إضافة مبلغ أيضًا).",
      "itemsPlaceholder": "مثال: جزّازة عشب، مقصّة (مفصولة بفواصل)", "sendOffer": "إرسال عرض المقايضة", "createFail": "تعذّر إرسال العرض.",
      "errName": "يرجى إدخال اسمك.", "errEmail": "يرجى إدخال بريد إلكتروني صالح.", "errItems": "صِف عنصرًا واحدًا على الأقل تقدّمه."
    },
    "classifieds": {
      "listingType": "نوع الإعلان", "typeSellOnly": "للبيع فقط", "typeSwapOnly": "للمقايضة فقط", "typeSellOrSwap": "بيع أو مقايضة", "typeFree": "مجاني", "typeWanted": "مطلوب",
      "swapWantedTitle": "ماذا تريد في المقابل؟", "swapAddOwn": "أضِف عنصرك…", "openToOffers": "مفتوح للعروض",
      "swapPrefsHint": "هذه تفضيلات فقط – يمكن للآخرين تقديم شيء مختلف.", "sellSwapPriceHint": "يمكن للمشترين الشراء بهذا السعر أو تقديم عرض مقايضة.",
      "errSellSwapPrice": "يرجى إدخال سعر بيع لإعلان «بيع أو مقايضة»",
      "buyFor": "الشراء مقابل", "swapWantedShort": "مقايضة مطلوبة", "swapOpenAny": "مفتوح للأفكار", "otherOffersConsidered": "يتم النظر في العروض الأخرى",
      "contactToBuy": "تواصل للشراء", "makeSwapOffer": "تقديم عرض مقايضة", "statusSwapped": "تمت المقايضة!",
      "swappedNote": "الإعلانات التي تمت مقايضتها مخفية من البحث. يظل سجلك محفوظًا لك.",
      "editTypePrice": "تغيير نوع الإعلان / السعر (مثلاً بيع هذا العنصر أيضًا)", "editSwapNote": "سيرى المشترون «€… أو مقايضة» ويمكنهم تقديم عرض مقايضة. تبقى صورك ووصفك ومعرّف الإعلان كما هي.",
      "offersReceived": "عروض المقايضة المستلمة", "noOffersYet": "لا توجد عروض مقايضة بعد.", "errSave": "تعذّر حفظ التغييرات.",
      "title": "بيع / مفقود / موجود",
      "sellTab": "بيع",
      "hintCardTitle": "أين يجب أن أنشر هذا؟",
      "hintCardSell": "بيع غرض",
      "hintCardSellDesc": "استخدم تبويب بيع",
      "hintCardLostFound": "فقدت أو وجدت شيئاً",
      "hintCardLostFoundDesc": "استخدم تبويب المفقودات والموجودات",
      "hintCardPetSafety": "حيوان أليف مفقود أو مخاوف أمنية",
      "hintCardPetSafetyDesc": "استخدم مركز سلامة المجتمع",
      "searchPlaceholder": "البحث عن أغراض...",
      "postItem": "نشر إعلان",
      "noItems": "لم يتم العثور على أغراض",
      "tryDifferent": "جرّب كلمات بحث أو فلاتر مختلفة",
      "beFirst": "كن أول من ينشر شيئاً للبيع!",
      "itemFound": "غرض",
      "itemsFound": "أغراض",
      "negotiable": "قابل للتفاوض",
      "sold": "مباع",
      "description": "الوصف",
      "contactSeller": "الاتصال بالبائع",
      "expiresOn": "ينتهي هذا الإعلان في",
      "ownerActions": "لديك صلاحية المالك لهذا الإعلان.",
      "markSold": "وضع علامة مباع",
      "delete": "حذف",
      "deleteListing": "حذف الإعلان",
      "confirmSold": "وضع علامة مباع؟",
      "confirmDelete": "حذف الإعلان؟",
      "confirmDeleteDesc": "سيتم حذف الإعلان نهائياً.",
      "yesSold": "نعم، مباع",
      "yesDelete": "نعم، حذف",
      "posted": "تم نشر الإعلان!",
      "postedDesc": "إعلانك نشط الآن. سينتهي تلقائياً بعد 30 يوماً.",
      "saveLink": "احفظ هذا الرابط لإدارة إعلانك:",
      "viewListing": "عرض الإعلان",
      "browseMore": "تصفح المزيد",
      "photos": "صور",
      "itemTitle": "العنوان",
      "titlePlaceholder": "ماذا تبيع؟",
      "category": "الفئة",
      "price": "السعر",
      "optional": "اختياري",
      "priceHint": "اتركه فارغاً لـ \"قابل للتفاوض\"",
      "descLabel": "الوصف",
      "descPlaceholder": "صف الغرض، حالته، مميزاته...",
      "location": "الموقع",
      "locationPlaceholder": "مثال: وسط المدينة، الريتامار...",
      "contactInfo": "بيانات الاتصال الخاصة بك",
      "yourName": "الاسم",
      "namePlaceholder": "اسمك",
      "yourEmail": "البريد الإلكتروني",
      "emailPlaceholder": "بريدك@email.com",
      "yourPhone": "الهاتف",
      "addPhoto": "إضافة",
      "maxPhotos": "الحد الأقصى 6 صور",
      "posting": "جارٍ النشر...",
      "postForFree": "نشر مجاناً",
      "autoExpire": "تنتهي الإعلانات تلقائياً بعد 30 يوماً",
      "cat": {
        "Tools": "أدوات",
        "Furniture": "أثاث",
        "Cars & Vehicles": "سيارات ومركبات",
        "Electronics": "إلكترونيات",
        "Property": "عقارات",
        "Clothing & Fashion": "ملابس وأزياء",
        "Home & Garden": "منزل وحديقة",
        "Sports & Leisure": "رياضة وترفيه",
        "Baby & Kids": "أطفال ورضع",
        "General": "عام"
      },
      "statusAvailable": "متاح",
      "statusPending": "في انتظار الاستلام",
      "statusSold": "مباع",
      "changeStatus": "تغيير الحالة",
      "soldAutoRemove": "تتم إزالة العناصر المباعة تلقائياً بعد 3 أيام.",
      "errorStatus": "تعذر تحديث الحالة.",
      "emailSent": "تم إرسال رابط الإدارة إلى بريدك الإلكتروني",
      "emailSentDesc": "تحقق من صندوق الوارد للحصول على رابط التعديل أو الحذف.",
      "manageHelp": "برابط الإدارة يمكنك:",
      "manageEdit": "تعديل تفاصيل الإعلان",
      "managePending": "تعيين الحالة إلى 'في انتظار الاستلام'",
      "manageSold": "وضع علامة مباع (يُخفى بعد 3 أيام)",
      "manageDelete": "حذف الإعلان",
      "manageListing": "إدارة الإعلان",
      "manageYourListing": "إدارة إعلانك",
      "resendLink": "فقدت رابط الإدارة؟",
      "resendTitle": "الحصول على روابط الإدارة",
      "resendDesc": "أدخل البريد الإلكتروني الذي استخدمته عند النشر.",
      "resendEmailPlaceholder": "بريدك@email.com",
      "resendBtn": "إرسال",
      "resendSent": "تحقق من بريدك!",
      "resendSentDesc": "إذا كانت هناك إعلانات نشطة، فقد أرسلنا روابط الإدارة.",
      "resendErrEmail": "يرجى إدخال بريد إلكتروني صالح",
      "resendError": "حدث خطأ. حاول مرة أخرى."
    },
    "nearestMe": {
      "button": "الأقرب لي",
      "notSupported": "تحديد الموقع غير مدعوم في متصفحك",
      "denied": "تم رفض الوصول إلى الموقع. يمكنك البحث حسب المدينة.",
      "error": "تعذر تحديد موقعك. حاول مرة أخرى.",
      "townPlaceholder": "أدخل مدينة، مثال: ليون، فرنسا",
      "useTown": "استخدم المدينة",
      "townNotFound": "تعذر العثور على هذه المدينة. جرّب مدينة أكبر قريبة أو أضف الدولة."
    },
    "lostFound": {
      "title": "مفقودات ومعثورات",
      "searchPlaceholder": "البحث عن أغراض مفقودة ومعثور عليها...",
      "postItem": "نشر غرض مفقود أو معثور عليه",
      "noItems": "لم يتم العثور على أغراض",
      "beFirst": "انشر غرضاً مفقوداً أو معثوراً عليه لمساعدة مجتمعك.",
      "lost": "مفقود", "found": "معثور عليه", "lostOn": "فُقد", "foundOn": "عُثر عليه",
      "resolved": "تم الحل", "markResolved": "وضع علامة تم الحل", "contactPerson": "اتصال",
      "typeLabel": "هل هذا الغرض مفقود أو معثور عليه؟",
      "iLostSomething": "فقدت شيئاً", "iFoundSomething": "وجدت شيئاً",
      "itemTitle": "ما الذي فُقد/عُثر عليه؟",
      "titlePlaceholder": "مثال: كلب صغير بني، مفاتيح سيارة...",
      "category": "الفئة", "dateLost": "تاريخ الفقدان", "dateFound": "تاريخ العثور",
      "descPlaceholder": "صف الغرض، أين فُقد/عُثر عليه...",
      "locationLabel": "المنطقة / الموقع", "locationPlaceholder": "مثال: وسط المدينة...",
      "posted": "تم النشر!", "postedDesc": "منشورك نشط الآن. سينتهي بعد 30 يوماً.",
      "viewItem": "عرض الغرض", "browseMore": "تصفح المزيد", "postForFree": "نشر مجاناً",
      "cat": { "Pets": "حيوانات أليفة", "Keys": "مفاتيح", "Wallets/Bags": "محافظ/حقائب", "Documents/ID": "مستندات/هوية", "Phones/Electronics": "هواتف/إلكترونيات", "Other": "أخرى" }
    },
    "savedSearch": {
      "setAlert": "إنشاء تنبيه بحث",
      "title": "تنبيه البحث",
      "desc": "احصل على إشعار عند نشر أغراض جديدة تطابق بحثك.",
      "queryPlaceholder": "مثال: كنبة، دراجة، آيفون...",
      "anyCategory": "أي فئة",
      "emailPlaceholder": "بريدك الإلكتروني للإشعارات",
      "save": "حفظ التنبيه",
      "saving": "جارٍ الحفظ...",
      "saved": "تم حفظ التنبيه!",
      "savedDesc": "سنرسل لك بريداً إلكترونياً عند نشر أغراض مطابقة.",
      "errQuery": "يجب أن يكون مصطلح البحث حرفين على الأقل",
      "errEmail": "يرجى إدخال بريد إلكتروني صالح",
      "errSave": "فشل حفظ تنبيه البحث",
      "unsubscribed": "تم إلغاء الاشتراك",
      "unsubscribedDesc": "لن تتلقى إشعارات لهذا البحث بعد الآن.",
      "unsubscribeError": "فشل إلغاء الاشتراك",
      "unsubscribeErrorDesc": "ربما انتهت صلاحية هذا الرابط.",
      "backToClassifieds": "تصفح بيع / مفقود / موجود"
    },

    "legal": "قانوني",
    "nearbyDeals": "عروض وترويج قريبة",
    "nearbyDealsDesc": "تلقي عروض مدفوعة من أعمال لا تتابعها",
    "enableNotificationsFirst": "تابع نشاطًا تجاريًا أو فعّل الإشعارات لإدارة تفضيلاتك.",
    "account": "الحساب",
    "support": "الدعم",
    "privacySecurity": "الخصوصية والأمان",
    "helpCenter": "مركز المساعدة",
    "aboutApp": "حول Find-2-Day",
    "termsOfService": "الشروط والأحكام",
    "privacyPolicy": "سياسة الخصوصية",
    "cookiePolicy": "سياسة ملفات تعريف الارتباط",
    "disputePolicy": "سياسة النزاعات",
    "admin": "المشرف",
    "terms": "الشروط",
    "privacy": "الخصوصية",
    "cookies": "ملفات الارتباط",
    "deleteData": "حذف بياناتي",
    "deleteAccountTitle": "حذف الحساب والبيانات",
    "whatWillBeDeleted": "ما سيتم حذفه:",
    "deleteItem1": "حسابك وبيانات تسجيل الدخول",
    "deleteItem2": "قائمة الأعمال والصور (إن وجدت)",
    "deleteItem3": "المفضلات والإعدادات المحفوظة",
    "deleteItem4": "جميع البيانات الشخصية المرتبطة",
    "reasonOptional": "السبب (اختياري)",
    "reasonPlaceholder": "أخبرنا لماذا تغادر...",
    "requestDeletion": "طلب حذف الحساب",
    "emailDirectly": "يمكنك أيضاً إرسال طلبك مباشرة إلى:",
    "requestReceived": "تم استلام الطلب",
    "requestReceivedDesc": "تم تقديم طلب الحذف. سنعالجه خلال 30 يوماً.",
    "contactDirectly": "يمكنك أيضاً الاتصال بنا مباشرة على",
    "changePasswordTitle": "تغيير كلمة المرور",
    "memberSince": "عضو منذ",
    "businessAccount": "حساب تجاري",
    "regularAccount": "حساب مستخدم",
    "businessDashboard": "لوحة التحكم",
    "businessNotFound": "لم يتم العثور على الملف التجاري",
    "listingUnavailable": "هذا الإدراج التجاري لم يعد متاحًا.",
    "duplicateViewBtn": "عرض الإدراج",
    "claimRetiredTitle": "المطالبة لم تعد متاحة",
    "claimRetiredBody": "يعمل Find-2-Day الآن عبر التسجيل الذاتي. إذا كان لديك نشاط تجاري، فأنشئ إدراجك الخاص — لا حاجة للمطالبة بسجل موجود.",
    "claimRetiredRegister": "سجّل نشاطك التجاري",
    "backToHome": "العودة إلى الرئيسية",
    "townCityLabel": "البلدة / المدينة", "townCityPlaceholder": "مثال: مدريد", "countryLabel": "الدولة", "countrySelect": "اختر دولة", "regionLabel": "المنطقة / الولاية / المقاطعة", "regionPlaceholder": "مثال: الأندلس", "localAreaLabel": "الحي / المنطقة المحلية", "postcodeLabel": "الرمز البريدي", "regionLabel2": "المنطقة / الولاية", "provinceLabel": "المقاطعة", "provincePlaceholder": "مثال: ألميريا", "mapView": "خريطة", "mapNoCoords": "لا تتوفر مواقع خريطة لهذه الأعمال بعد. بدّل إلى عرض القائمة لرؤية جميع النتائج.", "directionsBtn": "الاتجاهات", "filterCountry": "الدولة", "filterRegion": "المنطقة / الولاية", "filterProvince": "المقاطعة", "filterTown": "البلدة / المدينة", "allCountries": "كل الدول", "allRegions": "كل المناطق", "allProvinces": "كل المقاطعات", "allTowns": "كل البلدات", "locationFilterLabel": "الموقع",
    "faqTitle": "الأسئلة الشائعة",
    "faq1q": "كيف أسجل نشاطي التجاري؟",
    "faq1a": "انقر على 'انضم كنشاط تجاري' واتبع عملية التسجيل المكونة من 5 خطوات.",
    "faq2q": "كيف تعمل الفواتير؟",
    "faq2a": "جميع الخطط تبدأ فوراً بعد الدفع — بدون فترة تجريبية مجانية.",
    "faq3q": "متى سيظهر نشاطي التجاري؟",
    "faq3a": "بعد موافقة المسؤول، عادة خلال 24-48 ساعة.",
    "contactUs": "اتصل بنا",
    "trialPeriod": "الفواتير",
    "subscriptionPlans": "خطط الاشتراك",
    "allRightsReserved": "جميع الحقوق محفوظة.",
    "aboutDescription": "Find-2-Day هي منصة الاكتشاف المحلية الخاصة بك. اعثر على المطاعم والفعاليات والأنشطة والعروض القريبة منك.",

    "findAmazing": "اعثر على تجارب رائعة بالقرب منك",
    "eventsWillAppear": "ستظهر فعاليات الأنشطة المحلية هنا قريباً!",
    "offersWillAppear": "عد قريباً للحصول على عروض رائعة!",
    "startExploring": "ابدأ باستكشاف الأنشطة التجارية واحفظ مفضلاتك!",

    "changePassword": "تغيير كلمة المرور",
    "backToHome": "العودة للصفحة الرئيسية",
    "days": "أيام",
    "enableNotifications": "تفعيل الإشعارات",
    "notificationSettings": "إعدادات الإشعارات",
    "visitWebsite": "زيارة الموقع",
    "featuresAmenities": "المرافق والخدمات",
    "noFeaturesYet": "لم تتم إضافة ميزات أو خدمات بعد.",
    "addFeatures": "إضافة ميزات وخدمات",
    "featureEditHint": "انقر على العناصر لإضافتها أو إزالتها. احفظ عند الانتهاء.",
    "reviewCount": "تقييمات",
    "reviewBy": "تقييم من",
    "ratingRequired": "يرجى إعطاء تقييم",
    "reviewTextMin": "10 أحرف على الأقل",
    "reviewTextMax": "500 حرف كحد أقصى",
    "charsRemaining": "أحرف متبقية",
    "submittingReview": "جارٍ الإرسال...",
    "reviewSubmitted": "تم إرسال التقييم!",
    "alreadyReviewed": "لقد قمت بكتابة تقييم بالفعل",
    "removeFavorite": "إزالة من المفضلة",
    "reportListing": "الإبلاغ عن الإعلان",
    "reportReview": "الإبلاغ عن التقييم",
    "loginToReport": "سجّل دخولك للإبلاغ",
    "loginToClaim": "سجّل دخولك للمطالبة",
    "signInToClaim": "سجّل دخولك للمطالبة",
    "claimThisBusiness": "المطالبة بهذا النشاط التجاري",
    "claimNowBtn": "المطالبة الآن",
    "claimBanner": "هل هذا نشاطك التجاري؟",
    "claimTopBannerText": "طالب بهذا الإعلان لإدارته",
    "claimToUnlock": "طالب بالإعلان لإدارته",
    "claimSubmitted": "تم تقديم المطالبة",
    "claimSubmittedDesc": "سنراجع طلبك ونتواصل معك.",
    "claimAutoApproved": "تمت الموافقة تلقائياً",
    "claimAutoApprovedDesc": "تمت الموافقة على مطالبتك!",
    "claimAlreadyClaimed": "تمت المطالبة بالفعل",
    "claimAlreadyPending": "المطالبة قيد المراجعة",
    "claimStatusApproved": "تمت الموافقة",
    "claimStatusPending": "قيد المراجعة",
    "claimStatusRejected": "مرفوض",
    "claimError": "خطأ في المطالبة",
    "alreadyListedClaim": "هذا النشاط التجاري مسجل بالفعل",
    "unclaimedListing": "إعلان غير مُطالب به",
    "unclaimedContactNotice": "بيانات الاتصال قد لا تكون محدثة",
    "verifiedOwner": "مالك موثق",
    "verifyingEmail": "جارٍ التحقق من البريد الإلكتروني...",
    "verifySuccessDesc": "تم التحقق من بريدك الإلكتروني.",
    "resetPasswordError": "خطأ في إعادة تعيين كلمة المرور",
    "token": "رمز",
    "expirestoday": "ينتهي اليوم",
    "groupSizesWelcome": "أحجام المجموعات مرحب بها",
    "firstFollowBoost": "تابع الأنشطة التجارية للحصول على تحديثات!",
    "followEmptyTitle": "لا توجد أنشطة متابَعة",
    "followEmptyDesc": "تابع الأنشطة التجارية لتلقي التحديثات",
    "followEmptyCta": "اكتشف الأنشطة التجارية",
    "notifIOSShort": "iOS: أضف إلى الشاشة الرئيسية",
    "notifAndroidShort": "Android: تثبيت",
    "notifGenericShort": "تفعيل الإشعارات",
    "disputePolicyTitle": "سياسة النزاعات والإبلاغ",
    "charity.applyForListing": "التقدم لإعلان مجتمعي أو خيري مجاني",
    "charity.charityBadge": "مجتمع وخيري",
    "planBasic": "أساسي", "perYear": "/سنة", "per6Months": "/6 أشهر", "per12Months": "/12 شهراً",
    "ivaIncluded": "شامل ضريبة القيمة المضافة",
    "basicMonthlyHint": "عرض الأعمال المؤسِّسة · 12 شهراً مجاناً — بدون بطاقة",
    "basicRestrictions": "إعلان + صور + اتصال فقط. بدون فعاليات أو عروض أو ترويج مدفوع.",
    "upgradeFromBasicTitle": "افتح الفعاليات والعروض والميزات",
    "upgradeFromBasicDesc": "ترقية إلى 6 أشهر (49 يورو شامل الضريبة) أو 12 شهراً (70 يورو شامل الضريبة).",
    "earnUpToPerSignup": "اربح حتى 20 يورو لكل اشتراك",
    "minPayoutHint": "يلزم حد أدنى {{amount}} يورو للسحب.",
    "payoutProgress": "تقدم السحب",
    "balanceLabel": "الرصيد",
    "eligibleForPayout": "قابل للسحب",
    "notYetEligible": "غير متاح بعد — استمر!",
    "pendingMaturing": "قيد الانتظار (قيد النضوج)",
    "pendingMaturingDesc": "عمولات في فترة الـ {{days}} يوماً للتصفية.",
    "availableForPayout": "متاح للسحب",
    "availableForPayoutDesc": "تجاوزت فترة الـ {{days}} يوماً وجاهزة للسحب.",
    "clearanceTooltip": "تصبح العمولات متاحة بعد {{days}} يوماً من تأكيد الدفع، بما يتوافق مع نافذة الاعتراضات لمعالج المدفوعات. ستحصل على المبلغ كاملاً — يستغرق النضوج {{days}} يوماً فقط.",
    "maturesInDays": "تنضج خلال {{count}} يوم",
    "maturesInDays_plural": "تنضج خلال {{count}} يوماً",
    "availableNow": "متاح",
    "min": "حد أدنى",
    "payoutCycleNote": "تتم مراجعة المدفوعات بعد فترة تصفية مدتها {{days}} يوماً (نافذة الاسترداد) وتتم معالجتها شهرياً من قبل فريق الإدارة.",
    "calendar": { "addToCalendar": "أضف إلى التقويم", "icsDownload": "Apple / Outlook (.ics)", "icsHint": "ملف تقويم عالمي", "googleCalendar": "تقويم Google", "googleHint": "يفتح في علامة تبويب جديدة" },
    "previewYourListing": "معاينة إعلانك",
    "previewYourListingHint": "شاهد كيف سيبدو إعلانك قبل الدفع. يفتح في علامة تبويب جديدة — لا يتم حفظ أي شيء بعد.",
    "waiverTitle": "بدء الخدمة فوراً",
    "waiverLabel": "أوافق على أن يتم نشر إعلاني على الفور وأتنازل عن حقي في الانسحاب خلال 14 يوماً بموجب قانون المستهلك في الاتحاد الأوروبي.",
    "waiverRequired": "يجب عليك الموافقة على التنازل عن حق الانسحاب للمتابعة.",
    "waiverLegalNote": "وفقاً للتوجيه الأوروبي 2011/83/EU، المادة 16 (م) — المحتوى الرقمي / الخدمات المقدمة فوراً.",
    "emergency": {
      "title": "أرقام الطوارئ", "subtitle": "منطقة ألميريا — انقر على أي رقم للاتصال",
      "disclaimerTitle": "في حالة طوارئ تهدد الحياة:", "disclaimerBody": "هذه الصفحة للمعلومات فقط.",
      "callNow": "اتصل بـ 112 الآن", "tapToCall": "انقر للاتصال",
      "footerNote": "آخر مراجعة في فبراير 2026.",
      "euEmergency": "الطوارئ (الاتحاد الأوروبي)", "euEmergencyDesc": "رقم موحد للشرطة والإسعاف والإطفاء في الاتحاد الأوروبي",
      "nationalPolice": "الشرطة الوطنية", "nationalPoliceDesc": "الجرائم الخطيرة والوثائق",
      "guardiaCivil": "الحرس المدني", "guardiaCivilDesc": "المناطق الريفية والطرق والحدود",
      "localPolice": "الشرطة المحلية", "localPoliceDesc": "القضايا المحلية ووقوف السيارات",
      "medical": "طوارئ طبية", "medicalDesc": "الإسعاف والخدمات الصحية العاجلة",
      "fire": "الإطفاء", "fireDesc": "الحرائق والإنقاذ",
      "dvSupport": "دعم ضحايا العنف الأسري", "dvSupportDesc": "خط مساعدة مجاني وسري على مدار 24/7",
      "torrecardenas": "مستشفى توريكارديناس", "torrecardenasDesc": "المستشفى العام الرئيسي في ألميريا",
      "ukConsulate": "القنصلية البريطانية (مالقة)", "ukConsulateDesc": "دعم المواطنين البريطانيين",
      "ieConsulate": "السفارة الأيرلندية (مدريد)", "ieConsulateDesc": "دعم المواطنين الأيرلنديين",
      "cat": { "primary": "طوارئ", "police": "شرطة", "medical": "طبي", "fire": "حريق", "support": "دعم", "consulate": "قنصلية" }
    },
    "holidays": {
      "title": "العطلات الرسمية", "subtitle": "إسبانيا والأندلس — 2026",
      "nextHoliday": "العطلة القادمة", "today": "اليوم", "tomorrow": "غداً", "inNDays": "خلال {{count}} أيام",
      "footerNote": "قد تختلف التواريخ حسب البلدية.",
      "scope": { "national": "وطني", "andalusia": "الأندلس", "almeria": "ألميريا" },
      "month": { "january": "يناير", "february": "فبراير", "march": "مارس", "april": "أبريل", "may": "مايو", "june": "يونيو", "july": "يوليو", "august": "أغسطس", "september": "سبتمبر", "october": "أكتوبر", "november": "نوفمبر", "december": "ديسمبر" },
      "newYear": "رأس السنة", "epiphany": "عيد الغطاس", "andalusiaDay": "يوم الأندلس",
      "maundyThursday": "خميس الأسرار", "goodFriday": "الجمعة العظيمة", "labourDay": "عيد العمال",
      "sanJuan": "سان خوان (ألميريا)", "assumption": "انتقال العذراء", "virgenDelMar": "Virgen del Mar (ألميريا)",
      "nationalDay": "اليوم الوطني الإسباني", "allSaints": "عيد جميع القديسين",
      "constitutionDay": "يوم الدستور", "immaculate": "الحبل بلا دنس", "christmas": "عيد الميلاد"
    },

    // Added Feb 2026 — auth, inbox, data deletion, trial, safety bulletin, guide
    "common": { "back": "رجوع", "loading": "جارٍ التحميل…", "optional": "اختياري" },
    "auth": {
      "pwStrongPlaceholder": "أنشئ كلمة مرور قوية",
      "pwReenter": "أعد إدخال كلمة المرور",
      "pwReenterFull": "يرجى إعادة إدخال كلمة المرور",
      "pwMin6": "6 أحرف على الأقل",
      "pwConfirm": "تأكيد كلمة المرور"
    },
    "businessAuth": {
      "loginTitle": "تسجيل دخول الأعمال",
      "loginSubtitle": "سجّل الدخول لإدارة بطاقة عملك",
      "signIn": "تسجيل الدخول",
      "signingIn": "جارٍ تسجيل الدخول…",
      "noAccount": "ليس لديك حساب؟",
      "registerHere": "سجّل هنا",
      "backHome": "العودة إلى الصفحة الرئيسية",
      "errInvalidType": "نوع الحساب غير صالح. استخدم حساب أعمال.",
      "errLoginFailed": "فشل تسجيل الدخول. يرجى المحاولة مرة أخرى.",
      "registerTitle": "سجّل عملك",
      "step1": "الخطوة 1: أنشئ حسابك",
      "step2": "الخطوة 2: بيانات العمل",
      "phName": "اسم عملك",
      "phCategory": "اختر فئة",
      "phAddress": "العنوان"
    },
    "helperAuth": {
      "loginTitle": "تسجيل دخول المساعدين",
      "loginSubtitle": "سجّل الدخول لرؤية إحالاتك وعمولاتك"
    },
    "inbox": {
      "title": "الإشعارات",
      "typeEvent": "فعالية", "typeOffer": "عرض", "typeSystem": "نظام", "typeSafety": "سلامة",
      "justNow": "الآن", "minsAgo": "منذ {{n}} دقيقة", "hoursAgo": "منذ {{n}} ساعة", "daysAgo": "منذ {{n}} يوم",
      "unreadCount": "{{n}} غير مقروءة", "sponsoredCount": "{{n}} مموّلة",
      "settingsTitle": "إعدادات الإشعارات", "markAllRead": "تحديد الكل كمقروء",
      "errLoad": "تعذّر تحميل الإشعارات", "errMarkAll": "فشل تحديد الكل كمقروء",
      "emptyEnableTitle": "تفعيل الإشعارات",
      "emptyEnableBody": "فعّل الإشعارات من صفحة عمل أو من الإعدادات لتصلك التنبيهات هنا.",
      "openSettings": "فتح الإعدادات",
      "emptyTitle": "لا توجد إشعارات بعد",
      "emptyBody": "عندما تنشر الأعمال التي تتابعها فعاليات أو عروضاً جديدة، ستظهر هنا.",
      "sponsored": "مموّل", "sponsoredTitle": "هذا عرض مموّل",
      "unread": "غير مقروء", "fallbackTitle": "إشعار"
    },
    "dataDeletion": {
      "title": "حذف حسابك",
      "subtitle": "هذا الإجراء نهائي ولا يمكن التراجع عنه.",
      "doneTitle": "تم حذف الحساب",
      "doneBody": "تم حذف حسابك نهائياً. جُعلت التقييمات العامة مجهولة الهوية. يمكنك التسجيل مجدداً في أي وقت بحساب جديد.",
      "doneSubCancelled": "تم إلغاء اشتراكك النشط.",
      "doneUnclaimed": "أُعيدت بطاقة عملك إلى حالة غير مُطالَب بها حتى يتمكن المجتمع من العثور عليها.",
      "backHome": "العودة إلى الصفحة الرئيسية",
      "signInRequired": "يتطلّب تسجيل الدخول",
      "signInBody": "عليك تسجيل الدخول لحذف حسابك.",
      "goSignIn": "اذهب إلى تسجيل الدخول",
      "deletedHeading": "محذوف نهائياً",
      "deletedItem1": "حسابك وبريدك الإلكتروني وكلمة المرور",
      "deletedItem2": "المفضلة المحفوظة وبريد الإشعارات",
      "deletedItem3": "اشتراكات الإشعارات وروابط الأجهزة",
      "deletedItem4": "أي بلاغات أو طلبات مُطالَبة معلّقة",
      "anonHeading": "مجهول الهوية (يُحتفظ به علناً بدون اسمك)",
      "anonItem1": "تقييماتك — تظهر بصفة 'مستخدم محذوف'",
      "anonItem2": "سجلات الإشراف/التدقيق التي تمت معالجتها",
      "bizHeading": "إذا كنت تمتلك بطاقة عمل",
      "bizItem1": "سيُلغى اشتراكك فوراً عبر Stripe",
      "bizItem2": "ستعود البطاقة إلى حالة غير مُطالَب بها",
      "bizItem3": "يمكنك المطالبة بها لاحقاً بحساب جديد",
      "legalHeading": "مُحتفَظ به لأسباب قانونية/ضريبية",
      "legalItem1": "فواتير Stripe (القانون الضريبي الإسباني: 6 سنوات)",
      "legalItem2": "سجل حذف مجهول الهوية (يُحفظ لمدة سنتين)",
      "reasonLabel": "سبب المغادرة",
      "reasonPlaceholder": "ساعدنا على التحسّن — ما الذي دفعك للمغادرة؟",
      "typeDeleteLead": "اكتب", "typeDeleteTrail": "للتأكيد",
      "deleting": "جارٍ الحذف…",
      "deletePermanent": "احذف حسابي نهائياً",
      "cancelKeep": "إلغاء، الاحتفاظ بحسابي",
      "errDefault": "تعذّر حذف الحساب. حاول مرة أخرى أو تواصل مع الدعم."
    },
    "trial": {
      "signupTitle": "ابدأ بتجربة مجانية لمدة 60 يوماً — لا حاجة إلى بطاقة",
      "signupBody": "جرّب Find-2-Day مجاناً 60 يوماً. أضف وسيلة دفع في أي وقت قبل اليوم 60 للاستمرار. إذا لم تُضِف واحدة، ستُوقَف فعالياتك وعروضك تلقائياً — تبقى بطاقتك مرئية.",
      "signupCta": "ابدأ تجربة مجانية لمدة 60 يوماً — لا حاجة إلى بطاقة",
      "includesTrialBadge": "تتضمّن تجربة مجانية لمدة 60 يوماً — لا حاجة إلى بطاقة",
      "instantListingTrialDesc": "جميع الأعمال مجانية حالياً لمدة 12 شهراً بموجب عرض الأعمال المؤسِّسة — بدون بطاقة.",
      "bulletReminders": "سنُذكّرك قبل انتهاء التجربة بـ 14 و 7 و 2 أيام",
      "paymentLabel": "تجربة مجانية", "pausedLabel": "متوقفة",
      "feedbackPrompt": "هل تُخبرنا السبب؟ ذلك يساعدنا على التحسّن.",
      "feedbackThanks": "شكراً — نُقدّر ذلك.",
      "feedbackSend": "إرسال",
      "feedbackError": "تعذّر إرسال الملاحظات الآن.",
      "feedbackNotePlaceholder": "هل تودّ إضافة شيء (اختياري)",
      "reasonNotReady": "لست جاهزاً بعد",
      "reasonPriceTooHigh": "السعر مرتفع",
      "reasonPreferMonthly": "أفضّل الدفع شهرياً",
      "reasonOther": "أخرى"
    },
    "safety": {
      "title": "مركز سلامة المجتمع",
      "subtitle": "تحديثات الطوارئ الرسمية وتقارير المجتمع والمساعدة المحلية أثناء الحوادث.",
      "disclaimer": "هذه ليست خدمة شرطة. في حالات الطوارئ اتصل بـ 112. يراجع فريقنا المنشورات قبل النشر. لا نقبل أسماء أو اتهامات أو لوحات سيارات أو معلومات خاصة.",
      "empty": "لا توجد بلاغات بعد لهذا المرشّح.",
      "submitCta": "+ قدّم بلاغاً",
      "myPosts": "بلاغاتي",
      "verifiedResident": "مقيم/ة موثّق/ة في {{town}}",
      "publishedOn": "نُشر في {{date}}",
      "allTowns": "كل البلدات", "allCategories": "كل الفئات",
      "category": {
        "incident_factual": "حادثة (واقعية)",
        "safety_tip": "نصيحة سلامة",
        "lost_pet": "حيوان أليف مفقود",
        "community_alert": "تنبيه المجتمع"
      },
      "report": {
        "button": "إبلاغ",
        "title": "إبلاغ عن هذا التنبيه",
        "placeholder": "لماذا هذا التنبيه مشكلة؟",
        "submit": "إرسال البلاغ",
        "thanks": "شكراً — سنراجعه.",
        "alreadyReported": "لقد أبلغت عن هذا التنبيه بالفعل."
      },
      "filterTown": "تصفية حسب البلدة",
      "filterCategory": "الفئة",
      "categoryHint": {
        "incident_factual": "ملاحظة قصيرة وواقعية عمّا حدث. بدون أسماء ولا اتهامات.",
        "safety_tip": "نصيحة عامة تساعد الجيران على السلامة.",
        "lost_pet": "حيوان أليف مفقود. صف الحيوان وآخر مكان شوهد فيه، واستخدم المنصة للتواصل — بدون عناوين منزلية.",
        "community_alert": "تنبيه قصير الأجل (يُحذف تلقائياً بعد 24 ساعة)."
      },
      "expiresIn": "مرئي لمدة {{value}}",
      "submit": {
        "title": "قدّم تنبيه سلامة محلي",
        "intro": "شارك ملاحظة قصيرة وواقعية مع جيرانك الموثَّقين. يراجع فريقنا كل منشور قبل نشره.",
        "town": "البلدة (إقليم ألميريا فقط)",
        "townPlaceholder": "اختر بلدتك",
        "categoryLabel": "ما نوع هذا المنشور؟",
        "titleLabel": "العنوان",
        "titlePlaceholder": "ملخص قصير (حتى 80 حرفاً)",
        "bodyLabel": "التفاصيل",
        "bodyPlaceholder": "نص عادي فقط. بدون روابط أو أسماء أو اتهامات أو لوحات سيارات أو معلومات خاصة. حتى 500 حرف.",
        "rules": "بإرسال هذا التنبيه، أؤكد:",
        "rulesNoNames": "لم أذكر اسم أي شخص.",
        "rulesNoAccusations": "لا أتهم أحداً بجريمة.",
        "rulesNoPlates": "لم أُدرج لوحة سيارة.",
        "rulesNoPrivate": "لم أُدرج عنواناً أو رقم هاتف أو معلومات خاصة أخرى.",
        "confirmCheckbox": "أؤكد: بدون أسماء، بدون اتهامات، بدون لوحات، بدون معلومات خاصة.",
        "submitButton": "إرسال للمراجعة",
        "needTown": "اختر بلدة",
        "needTitle": "أضف عنواناً (4 أحرف على الأقل)",
        "needBody": "أضف تفاصيل (10 أحرف على الأقل)",
        "needConfirm": "ضع علامة في خانة التأكيد",
        "submitting": "جارٍ الإرسال…",
        "successTitle": "تم الإرسال — قيد المراجعة",
        "successBody": "سيُراجع فريقنا منشورك. ستصلك رسالة عند الموافقة أو إذا كانت هناك تعديلات مطلوبة.",
        "characters": "{{count}} حرفاً",
        "loginRequired": "يرجى تسجيل الدخول لإرسال تنبيه.",
        "signIn": "تسجيل الدخول",
        "rateLimitHit": "بلغت الحد الأقصى — يمكنك إرسال حتى 3 نشرات كل 24 ساعة."
      },
      "mine": {
        "empty": "لم تُرسل أي نشرات بعد.",
        "status": {
          "pending": "قيد المراجعة",
          "approved": "منشور",
          "rejected": "لم يُنشر",
          "expired": "منتهي",
          "takedown": "تمت إزالته"
        },
        "rejectionReason": "السبب: {{reason}}",
        "back": "العودة إلى التنبيه",
        "markFound": "وضع علامة كموجود",
        "markFoundSuccess": "تم وضع علامة كموجود — شكراً لإبلاغنا!",
        "markFoundFailed": "تعذّر وضع علامة كموجود.",
        "closedFound": "مغلق — تم العثور على الحيوان الأليف",
        "edit": "تعديل",
        "editHeading": "تعديل التنبيه",
        "editTown": "المدينة",
        "editCategory": "الفئة",
        "editTitleField": "العنوان",
        "editBody": "التفاصيل",
        "editPendingNote": "تعديل تنبيه منشور يعيده إلى المراجعة قبل نشره مرة أخرى.",
        "editCancel": "إلغاء",
        "editSave": "حفظ التغييرات",
        "editSuccessPending": "تم الحفظ — عاد تنبيهك إلى المراجعة وسيُنشر بعد الموافقة.",
        "editSuccessLive": "تم تحديث تنبيهك.",
        "editFailed": "تعذّر حفظ التغييرات. حاول مرة أخرى.",
        "editLiveNote": "يبقى تعديلك منشوراً على الفور — لن يتم إشعار المتابعين إلا إذا اخترت ذلك أدناه.",
        "editNotifyFollowers": "إشعار المتابعين بهذا التحديث",
        "editSuccessNotified": "تم الحفظ — تم إشعار متابعيك بالتحديث."
      }
    },
    "guideSubInstant": "تُصبح بطاقتك مباشرةً بمجرد تأكيد اشتراكك (أو فوراً عند بدء تجربة مجانية لمدة 60 يوماً على خطة 12 شهراً).",
    "faq2a": "جميع الأعمال مجانية حالياً لمدة 12 شهراً بموجب عرض الأعمال المؤسِّسة — بدون بطاقة، بدون دفع خلال الفترة المؤسِّسة. سيتم الإعلان عن الأسعار المستقبلية (في حال تقديمها) قبل تطبيقها بوقت كافٍ.",

    // PASS 2 (Feb 2026)
    "emergency": {
      "title": "أرقام الطوارئ",
      "subtitle": "منطقة ألميريا — اضغط على أي رقم للاتصال",
      "disclaimerTitle": "في حالة طوارئ تهدد الحياة:",
      "disclaimerBody": "هذه الصفحة إعلامية وقد لا تعكس آخر التغييرات الرسمية.",
      "callNow": "اتصل بـ 112 الآن",
      "tapToCall": "اضغط للاتصال",
      "footerNote": "آخر مراجعة فبراير 2026. تحقّق دائماً من المعلومات الحرجة من مصادر رسمية.",
      "euEmergency": "الطوارئ (الاتحاد الأوروبي)",
      "euEmergencyDesc": "رقم موحّد للشرطة والإسعاف والإطفاء في الاتحاد الأوروبي",
      "nationalPolice": "Policía Nacional",
      "nationalPoliceDesc": "الشرطة الوطنية — الجرائم الخطيرة ووثائق الهوية",
      "guardiaCivil": "Guardia Civil",
      "guardiaCivilDesc": "المناطق الريفية والطرق والحدود",
      "localPolice": "Policía Local",
      "localPoliceDesc": "حوادث محلية، وقوف السيارات، شؤون بلدية",
      "medical": "طوارئ طبية",
      "medicalDesc": "الإسعاف والخدمات الصحية العاجلة",
      "fire": "الإطفاء",
      "fireDesc": "Bomberos — حرائق وإنقاذ وفيضانات",
      "dvSupport": "دعم ضحايا العنف الأسري",
      "dvSupportDesc": "خط سري 24/7 (مجاني، لا يظهر في فواتير الهاتف)",
      "torrecardenas": "مستشفى Torrecárdenas",
      "torrecardenasDesc": "المستشفى العام الرئيسي في مدينة ألميريا",
      "ukConsulate": "القنصلية البريطانية (مالقة)",
      "ukConsulateDesc": "دعم المواطنين البريطانيين في جنوب إسبانيا",
      "ieConsulate": "السفارة الأيرلندية (مدريد)",
      "ieConsulateDesc": "دعم المواطنين الأيرلنديين — تغطي كل إسبانيا",
      "cat": { "primary": "طوارئ", "police": "شرطة", "medical": "طبي", "fire": "حرائق", "support": "دعم", "consulate": "قنصلية" }
    },
    "holidays": {
      "title": "العطل الرسمية",
      "subtitle": "إسبانيا والأندلس — 2026",
      "nextHoliday": "العطلة القادمة",
      "today": "اليوم",
      "tomorrow": "غداً",
      "inNDays": "بعد {{count}} يوماً",
      "footerNote": "قد تختلف التواريخ حسب البلدية. تحقّق من مجلس بلدتك عند الحاجة.",
      "scope": { "national": "وطني", "andalusia": "الأندلس", "almeria": "ألميريا" },
      "month": { "january": "يناير", "february": "فبراير", "march": "مارس", "april": "أبريل", "may": "مايو", "june": "يونيو", "july": "يوليو", "august": "أغسطس", "september": "سبتمبر", "october": "أكتوبر", "november": "نوفمبر", "december": "ديسمبر" },
      "newYear": "رأس السنة الميلادية",
      "epiphany": "عيد الغطاس (الملوك الثلاثة)",
      "andalusiaDay": "يوم الأندلس",
      "maundyThursday": "خميس العهد",
      "goodFriday": "الجمعة العظيمة",
      "labourDay": "عيد العمال",
      "sanJuan": "سان خوان (ألميريا)",
      "assumption": "عيد انتقال مريم العذراء",
      "virgenDelMar": "عذراء البحر (ألميريا)",
      "nationalDay": "اليوم الوطني الإسباني",
      "allSaints": "عيد جميع القديسين (مُؤجَّل)",
      "constitutionDay": "يوم الدستور",
      "immaculate": "الحبل بلا دنس",
      "christmas": "عيد الميلاد"
    },
    "calendar": {
      "addToCalendar": "أضف إلى التقويم",
      "icsDownload": "Apple / Outlook (.ics)",
      "icsHint": "ملف تقويم عالمي",
      "googleCalendar": "تقويم Google",
      "googleHint": "يُفتح في علامة تبويب جديدة"
    },
    "community": {
      "title": "أدوات المجتمع",
      "safetySub": "جيران موثَّقون، ملاحظات واقعية",
      "emergencySub": "شرطة، طبي، 112",
      "holidaysSub": "إسبانيا والأندلس 2026"
    }
  }
};

export default ar;
